module.exports = __webpack_public_path__ + "static/media/Inbox.0fa419ff.svg";